import "@/App.css";
import Presentation from "@/components/Presentation";

function App() {
  return (
    <div className="App">
      <Presentation />
    </div>
  );
}

export default App;
